import script from "./setPwd.vue?vue&type=script&setup=true&name=SetPwd&lang=js"
export * from "./setPwd.vue?vue&type=script&setup=true&name=SetPwd&lang=js"

import "./setPwd.vue?vue&type=style&index=0&id=af8df5de&scoped=true&lang=css"
import "./setPwd.vue?vue&type=style&index=1&id=af8df5de&lang=css"

import exportComponent from "D:\\Jawsro\\company\\hujing\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af8df5de"]])

export default __exports__